import * as React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';

import { CrystalButtonPopup, Loading } from 'components';
import { footerZIndex } from 'configs';
import { ROUTES } from 'consts';
import { ZoneCreateDialog } from 'dialogs/zone';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useBuildings } from 'pages/buildings/buildings.hook';
import { AnnouncementOutlined, Edit } from '@mui/icons-material';

export const DashboardNavigator = () => {
  const theme = useTheme();
  const up_md = useMediaQuery(theme.breakpoints.up('md'));
  const location = useLocation();
  const navigate = useNavigate();
  const { orgSlug, isAdmin, canCreateBuildings } = useAppSelector(selectCurrentUserInfo);
  const [visibleZoneCreateDialog, setVisibleZoneCreateDialog] = React.useState<boolean>(false);
  const [loading, buildings] = useBuildings();
  const pathname = location.pathname.replace(`/${orgSlug}/`, '');
  const isDashboardNavigator = pathname === ROUTES.DASHBOARD || pathname === `${ROUTES.DASHBOARD}/`;

  React.useEffect(() => {
    if (isDashboardNavigator && !loading && (buildings || []).length > 0) {
      navigate(`${buildings[0].id}`);
    }
  }, [isDashboardNavigator, loading, buildings]);

  React.useEffect(() => {
    if (isDashboardNavigator && !loading && (buildings || []).length > 0) {
      navigate(`${buildings[0].id}`);
    }
  }, [isDashboardNavigator, loading, buildings]);

  const items = [
    ...(canCreateBuildings
      ? [
          {
            id: 1,
            label: 'Building',
            onClick: () => navigate(`/${orgSlug}/${ROUTES.BUILDINGS}/new`),
          },
        ]
      : []),
    {
      id: 2,
      label: 'Zone',
      onClick: () => setVisibleZoneCreateDialog(true),
    },
  ];

  return (
    <>
      <Box sx={{ padding: 3 }}>
        {isAdmin && (
          <Box
            sx={
              up_md
                ? { position: 'absolute', top: 24, right: 24, zIndex: footerZIndex }
                : { width: 30, height: 30, marginLeft: 'auto', marginBottom: 3 }
            }
          >
            <CrystalButtonPopup items={items} />
          </Box>
        )}

        <Outlet />

        {isDashboardNavigator && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: `calc(100vh - 270px)`,
              minHeight: 400,
            }}
          >
            {loading ? (
              <Loading text="Loading buildings..." height={400} />
            ) : (buildings || []).length === 0 ? (
              <>
                <AnnouncementOutlined color="primary" sx={{ fontSize: 40 }} />

                <Typography color="textSecondary" sx={{ marginTop: 2 }}>
                  {canCreateBuildings ? 'Set up a building to start' : 'No buildings are available'}
                </Typography>

                {canCreateBuildings && (
                  <Button
                    startIcon={<Edit />}
                    onClick={() => navigate(`/${orgSlug}/${ROUTES.BUILDINGS}/new`)}
                    sx={{ marginTop: 4, paddingX: 2 }}
                  >
                    Let’s get started
                  </Button>
                )}
              </>
            ) : null}
          </Box>
        )}
      </Box>

      <ZoneCreateDialog visible={visibleZoneCreateDialog} setVisible={setVisibleZoneCreateDialog} />
    </>
  );
};
